import React from 'react';
import { Heart, MessageCircle, Eye, Share2, Instagram, Facebook } from 'lucide-react';

const Stat = ({ Icon, v, label }) => (
  <span className="flex items-center gap-1" title={label}><Icon size={12} /> {v ?? '–'}</span>
);

export default function PostStats({ stats }) {
  if (!stats) return null;
  return (
    <div className="space-y-1 text-xs text-white/70" data-testid="post-stats">
      {stats.instagram && (
        <div className="flex items-center gap-3" data-testid="post-stats-instagram">
          <Instagram size={12} className="text-pink-400" />
          <Stat Icon={Heart} v={stats.instagram.likes} label="Mi piace" />
          <Stat Icon={MessageCircle} v={stats.instagram.comments} label="Commenti" />
          <Stat Icon={Eye} v={stats.instagram.views ?? stats.instagram.reach} label="Visualizzazioni" />
        </div>
      )}
      {stats.facebook && (
        <div className="flex items-center gap-3" data-testid="post-stats-facebook">
          <Facebook size={12} className="text-sky-400" />
          <Stat Icon={Heart} v={stats.facebook.likes} label="Reazioni" />
          <Stat Icon={MessageCircle} v={stats.facebook.comments} label="Commenti" />
          <Stat Icon={Share2} v={stats.facebook.shares} label="Condivisioni" />
          {stats.facebook.views != null && <Stat Icon={Eye} v={stats.facebook.views} label="Visualizzazioni" />}
        </div>
      )}
    </div>
  );
}
